import styled from '@emotion/styled';
import { BodyMedium, LabelSmall, TitleLarge } from './Typography';

/**
 * CardTypography.tsx
 *
 * This file contains the typography components for the cards on the page of the page.
 * They include additional padding and margins to help with the layout of the page.
 * For core typography see Typography.tsx
 */

interface CardTitleProps {
    fontWeight?: number;
}

export const CardTitle = styled(TitleLarge)<CardTitleProps>`
    font-weight: ${(props) => props.fontWeight || 400};
    text-transform: capitalize;
`;

export const CardTitleCentered = styled(CardTitle)`
    text-align: center;
    display: flex;
    align-items: center;
    align-self: center;
    gap: 0.5rem;
`;

export const CardSubtitle = styled(BodyMedium)<CardTitleProps>`
    font-weight: ${(props) => props.fontWeight || 400};
`;

export const CardSubtitleCentered = styled(CardSubtitle)`
    text-align: center;
    display: flex;
    align-self: center;
`;

export const CardTitleContext = styled(LabelSmall)`
    color: ${(props) => props.theme.color.text};
`;

export const CardItem = styled(LabelSmall)`
    color: ${(props) => props.theme.color.textBody};
    margin-bottom: 0.875rem;
`;
